import PiBooleanProperty from "../../../components/PiProperties/PiBooleanProperty";
import PiNumberProperty from "../../../components/PiProperties/PiNumberProperty";
import type { InteractionPropertiesEditor } from "../../interaction_factory/InteractionFactory";
import type Interaction from "../../../models/interactions/Interaction";
import type { InteractionProperty } from "../../../models/InteractionProperty";

export const InstantSpeedPropertiesEditor: InteractionPropertiesEditor = {
  handledPropertyIds: ["instant", "speed"],
  render: (interaction, actions) =>
    interaction.properties?.some((property) => property.id === "instant") ? (
      <InstantSpeedProperties
        interaction={interaction}
        onChange={actions.updateProperty}
      />
    ) : null,
};

export function InstantSpeedProperties({
  interaction,
  onChange,
  showBehaviorLabel = true,
}: {
  interaction: Interaction;
  onChange: (property: InteractionProperty) => void;
  showBehaviorLabel?: boolean;
}) {
  const instantProperty = interaction.properties?.find(
    (property) => property.id === "instant"
  );
  const speedProperty = interaction.properties?.find(
    (property) => property.id === "speed"
  );

  if (!instantProperty) return null;

  const isInstant = Boolean(instantProperty.value);

  return (
    <div
      data-testid="interaction-behavior-settings"
      className="flex flex-col gap-[8px] pb-[8px]"
    >
      {showBehaviorLabel && (
        <div className="text-[12px] font-semibold uppercase tracking-[0.08em] text-creator-text-soft">
          Behavior
        </div>
      )}
      <PiBooleanProperty
        interactionProperty={instantProperty}
        onChange={onChange}
      />
      {!isInstant && speedProperty && (
        <PiNumberProperty
          interactionProperty={speedProperty}
          onChange={onChange}
        />
      )}
    </div>
  );
}
